import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { createTeamProjectSummary, type TeamProjectSummary } from './TeamProjectSummary';

type TeamCustomRoleSummaryItemProps = {
  appliedOn: number;
  key: string;
  name: string;
  projects: TeamProjectSummary;
};

export class TeamCustomRoleSummaryItem extends Record<TeamCustomRoleSummaryItemProps>({
  appliedOn: 0,
  key: '',
  name: '',
  projects: createTeamProjectSummary({}),
}) {}

export const createTeamCustomRoleSummaryItem = (props?: CreateFunctionInput<TeamCustomRoleSummaryItem>) =>
  props instanceof TeamCustomRoleSummaryItem ? props : new TeamCustomRoleSummaryItem(fromJS(props));
